import styled from "styled-components";
import { motion } from "framer-motion";
import React from "react";

export interface MetricCardProps {
  title: string;
  value: string | number;
  icon?: React.ComponentType<{ size?: number; className?: string }>;
  trend?: number;
  className?: string;
  delay?: number;
}


export const Card = styled(motion.div)`
  background: ${({ theme }) => theme.colors.cardBg || "#ffffff"};
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  p{
    margin: 0;
  }

  &:hover {
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  }
`;

export const BackgroundIcon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 16px;
  opacity: 0.1;
  transition: all 0.5s ease;

  ${Card}:hover & {
    opacity: 0.2;
    transform: scale(1.1);
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  position: relative;
  z-index: 10;
`;

export const Title = styled.h3`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
  color: #64748b;
`;

export const IconWrapper = styled.div`
  padding: 8px;
  background: #eff6ff;
  border-radius: 8px;
  color: #2563eb;
`;

export const Value = styled.p`
  font-size: 32px;
  font-weight: bold;
  color: #0f172a;
  display: block;
`;

export const TrendContainer = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  font-size: 14px;
  position: relative;
  z-index: 10;
`;

export const TrendValue = styled.span<{ $type: "up" | "down" | "neutral" }>`
  display: flex;
  align-items: center;
  font-weight: 600;
  color: ${({ $type }) =>
    $type === "up"
      ? "#22c55e"
      : $type === "down"
      ? "#ef4444"
      : "#94a3b8"};
`;

export const TrendLabel = styled.span`
  color: #94a3b8;
  margin-left: 8px;
  font-size: 12px;
`;
